import { requestCalculateAnalytics } from '../../../libs/calculate-analytics'
import { countCartProductsByDoors } from '../../../libs/cart'
import { isPageMatches } from '../../../libs/url'
import { AppThunk } from '../../../model/model'
import {
  cartProductsDetailsSelector,
  cartProductsSelector,
  filteredCartProductsSelector,
} from '../selectors/cart'
import { slice } from '../slice'

export const updateAnalytics = (): AppThunk => (dispatch, getState) => {
  const state = getState()
  const cartProductsDetails = cartProductsDetailsSelector(state)
  const cartProductsFiltered = filteredCartProductsSelector(state)
  const cartProductsFilteredByValidBrands = cartProductsSelector(state)

  const statistics = {
    itemsByDoors: countCartProductsByDoors(cartProductsFilteredByValidBrands),
  }
  if (isPageMatches('cart')) {
    requestCalculateAnalytics(cartProductsFiltered, state.brands.items, cartProductsDetails).then(
      analytics => {
        dispatch(slice.actions.setAnalytics({ analytics: analytics, statistics: statistics }))
      },
    )
  } else {
    dispatch(slice.actions.setAnalytics({ analytics: undefined, statistics: statistics }))
  }
}
